module.exports = __webpack_public_path__ + "static/media/phone-area-card.c848e919.gif";